import { render } from "./Menu.vue?vue&type=template&id=6f60410d"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=6f60410d&lang=css"

import exportComponent from "E:\\Andrei\\munca\\Isoletta\\isoletta-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__